// 上面的搜索框的 placeholder 配置
export const inputPlaceholderOptions = {
  name: '调查员姓名',
  phone: '调查员手机号',
  taskName: '任务名称',
  taskState: '任务状态'
}

// 可以搜索的状态
export const taskStatusOptions = [
  {
    label: '已分配',
    value: 6
  },
  {
    label: '已关闭',
    value: 7
  },
  {
    label: '已结算',
    value: 8
  },
  {
    label: '邀请中',
    value: 9
  },
  {
    label: '已邀请',
    value: 10
  }
]
export const taskStatusOptionsInvestment = [
  {
    label: '已分配',
    value: 6
  },
  {
    label: '已关闭',
    value: 7
  },
  {
    label: '已结算',
    value: 8
  },
  {
    label: '邀请中',
    value: 9
  },
  {
    label: '已邀请',
    value: 10
  },
  {
    label: '已承接',
    value: 11
  },
  {
    label: '已拒接',
    value: 12
  }
]

// 表格列的名字配置
export const tableColumnNameOptions = {
  name: '调查员',
  concat: '手机号',
  taskName: '任务名称',
  taskStatus: '任务状态',
  settleMethod: '结算类型',
  settleMode: '结算方式',
  expectedQuantity: '数量',
  unitPriceYuan: '单价',
  taskEndTime: '任务截止时间',
  // count: '答卷数量',
  // price: '答卷单价',
  commitCount: '提交数量',
  effectiveCount: '有效数量',
  switch: '任务开关'
}

export const dialogData = [
  {
    title: '步骤一： 添加调查员',
    content: '面对面访问由调查员执行，请先添加调查员，告知调查员下载安装面访APP'
  },
  {
    title: '步骤二：进行面访设置',
    content: '设置面访质控的多媒体素材，可在调查员录入答卷时开启强制录音、前后置摄像头录像，用于答卷审核'
  },
  {
    title: '步骤三：分配面访任务',
    content: '选择调查员分配面访任务，包含截止时间、答卷数量和单价，完成后调研任务将下发到具体调查员面访APP的任务列表'
  },
  {
    title: '步骤四：线下面访',
    content: '调查员接到调研任务后，现场调研并通过面访APP记录上传调研答卷'
  },
  {
    title: '步骤五：审核答卷',
    content: '审核员对回收答卷进行审核，支持只审核重点问题，一键审核通过和设置多级审核'
  },
  {
    title: '步骤六：佣金结算',
    content: '面访任务完成后，管理员可在线结算调查员佣金，调查员可通过面访APP进行提现'
  }
]

export const newFieldOptions = {
  taskName: 'executionName',
  endTime: 'executionValidateTo',
  count: 'executionQuantity',
  price: 'executionSingleAmount'
}

export const offlineOption = {
  column: [
    {
      label: '调查员',
      value: 'executorName',
      width: '160px',
      align: 'left',
      name: 'executorName'
    },
    {
      label: '手机号',
      value: 'executorPhone',
      width: '120px',
      align: 'left',
      name: 'executorPhone'
    },
    {
      label: '任务名称',
      value: 'executionName',
      width: '220px',
      align: 'left',
      name: 'executionName'
    },
    {
      label: '任务截止时间',
      value: 'executionValidateTo',
      width: '180px',
      align: 'left',
      name: 'executionValidateTo'
    },
    {
      label: '任务状态',
      value: 'status',
      width: '80px',
      align: 'left',
      name: 'status'
    },
    {
      label: '结算类型',
      value: 'settleMethod',
      width: '90px',
      align: 'left',
      name: 'settleMethod'
    },
    {
      label: '结算方式',
      value: 'settleMode',
      width: '410px',
      align: 'left',
      align: 'left',
      name: 'settleMode'
    },
    {
      label: '状态',
      value: 'offlineStatus',
      width: '80px',
      align: 'left',
      name: 'offlineStatus'
    },
    {
      align: 'left',
      label: '操作',
      value: 'opt',
      width: 150,
      fixed: 'right'
    }
  ]
}
